import type { OpenSearchQueryBuilder } from './open-search-builder';

const CURRENT_EMPLOYER_FORM_TYPE = 'currentEmployer';
const PRIOR_EMPLOYER_FORM_TYPE = 'priorEmployer';
const CURRENT_PARTNER_PRIOR_PERIOD_SIGN_REQUEST_TYPE = 'current_partner_prior_period';

export function applyPslfFormTypeFilter(builder: OpenSearchQueryBuilder, formType?: string | null) {
  if (formType === CURRENT_EMPLOYER_FORM_TYPE) {
    builder.addFilter({
      bool: {
        should: [
          { term: { pslf_form_type_keyword: CURRENT_EMPLOYER_FORM_TYPE } },
          {
            term: {
              pslf_form_employer_sign_request_type_keyword:
                CURRENT_PARTNER_PRIOR_PERIOD_SIGN_REQUEST_TYPE,
            },
          },
        ],
        minimum_should_match: 1,
      },
    });
  } else if (formType === PRIOR_EMPLOYER_FORM_TYPE) {
    builder.addFilter({
      bool: {
        must: [{ term: { pslf_form_type_keyword: PRIOR_EMPLOYER_FORM_TYPE } }],
        must_not: [
          {
            term: {
              pslf_form_employer_sign_request_type_keyword:
                CURRENT_PARTNER_PRIOR_PERIOD_SIGN_REQUEST_TYPE,
            },
          },
        ],
      },
    });
  } else if (formType) {
    builder.mustTerm('pslf_form_type_keyword', formType);
  }

  return builder;
}
